import { render, staticRenderFns } from "./ShiftEvents.vue?vue&type=template&id=fe370a3e"
import script from "./ShiftEvents.js?vue&type=script&lang=js&external"
export * from "./ShiftEvents.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports